import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SSBISocialEmotional',
    label: 'SSBISocialEmotional',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
